<template>
  <!-- 轮播内容（吸底） -->
  <div class="settlement-float">
    <div class="settlement-container">
      <!-- 滚动区域 -->
      <div class="scroll-wrapper">
        <div class="scroll-track">
          <!-- 渲染两遍实现无缝循环 -->
          <div
            class="scroll-group"
            v-for="(group, gIndex) in [0, 1]"
            :key="'group-' + gIndex"
          >
            <div
              class="settlement-card"
              v-for="(item, index) in items"
              :key="'item-' + gIndex + '-' + index"
            >
              <!-- 用户头像 -->
              <div class="user-avatar">
                <img :src="item.avatar" :alt="item.name" />
              </div>

              <!-- 用户信息 -->
              <div class="user-info">
                <div class="xsgq1">
                  <div class="user-country xsgq">
                    <img
                      :src="country[item.country_id]?.img"
                      :alt="country[item.country_id]?.name"
                    />
                  </div>
                  <div class="user-name">{{ item.name }}</div>
                </div>
                <span class="user-uid">UID: {{ item.uid }}</span>
              </div>

              <!-- 结算金额 -->
              <div class="settle-amount">
                <span class="amount-label">{{ $t("settle.amount") }}</span>
                <span class="amount-value">
                  <span class="amount-symbol">$</span
                  >{{ formatAmount(item.amount) }}
                </span>
              </div>

              <!-- 产品类型 + 收益类别 -->
              <div class="product-info">
                <span class="product-type">{{ $t(item.productType) }}</span>
                <span class="income-type">{{ $t(item.incomeType) }}</span>
              </div>

              <!-- 状态 -->
              <div class="xsdg1">
                <div style="display: flex">
                  <div class="settle-status">
                    <span class="status-dot"></span>
                    <span class="status-text">{{ $t("settle.status") }}</span>
                  </div>
                </div>
                <div class="settle-time">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                    />
                  </svg>
                  <span>{{ formatTime(item.time) }}</span>
                </div>
              </div>

              <!-- 结算时间 -->
              <!-- <div class="settle-time">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                  />
                </svg>
                <span>{{ formatTime(item.time) }}</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SettlementCarousel",
  data() {
    return {
      items: [],
      country: {},
    };
  },
  created() {
    this.getIncomeRand();
  },
  methods: {
    // 获取收益随机数
    getIncomeRand() {
      this.$api.user.getIncomeRand().then((res) => {
        // 合并 server 和 token 两个数组
        const serverList = res.data.server || [];
        const tokenList = res.data.token || [];
        const country = res.data.country || {};
        const merged = [...serverList, ...tokenList];
        // 打乱顺序
        this.shuffle(merged);
        // 映射为组件需要的字段格式
        this.items = merged.map((item) => ({
          name: item.nickname,
          uid: String(item.uid),
          amount: item.amount,
          productType: item.category === 1 ? "settle.power" : "settle.rental",
          incomeType: item.type === 3 ? "settle.cycle" : "settle.basic",
          time: item.create_time,
          avatar: item.avatar,
          country_id: item.country_id,
        }));

        country.map((item) => {
          this.country[item.id] = item;
        });
      });
    },
    // 打乱数组顺序（Fisher-Yates）
    shuffle(arr) {
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
    },

    // 隐藏 UID 中间部分，只显示前2位和尾2位
    maskUid(uid) {
      if (!uid || uid.length <= 4) return uid || "--";
      const first = uid.slice(0, 2);
      const last = uid.slice(-2);
      return `${first}****${last}`;
    },
    // 昵称脱敏：保留首尾字符，中间用星号代替
    maskName(name) {
      if (!name) return "--";
      const str = String(name);
      if (str.length <= 1) return str;
      if (str.length === 2) return str[0] + "*";
      if (str.length === 3) return str[0] + "*" + str[2];
      // 4个及以上字符：保留首尾，中间用星号
      return str[0] + "*".repeat(str.length - 2) + str[str.length - 1];
    },

    // 格式化金额
    formatAmount(amount) {
      if (!amount) return "0.00";
      return amount.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    // 格式化时间
    formatTime(time) {
      if (!time) return "--";
      return time;
    },
  },
};
</script>

<style scoped>
/* ===== 浮动结算动态（吸底效果） ===== */
.settlement-float {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  padding: 12px 20px;
  background: rgba(10, 14, 26, 0.85);
  backdrop-filter: blur(20px);
  border-top: 1px solid rgba(0, 201, 81, 0.15);
  box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.4);
}

.settlement-container {
  max-width: 1200px;
  margin: 0 auto;
}

/* ===== 滚动区域 ===== */
.scroll-wrapper {
  overflow: hidden;
  border-radius: 12px;
  -webkit-mask-image: linear-gradient(
    90deg,
    transparent,
    #000 5%,
    #000 95%,
    transparent
  );
  mask-image: linear-gradient(
    90deg,
    transparent,
    #000 5%,
    #000 95%,
    transparent
  );
}

.scroll-track {
  display: flex;
  width: max-content;
  animation: scroll-left 60s linear infinite;
}

.scroll-track:hover {
  animation-play-state: paused;
}

@keyframes scroll-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.scroll-group {
  display: flex;
  gap: 12px;
  padding-right: 12px;
}

/* ===== 结算卡片 ===== */
.settlement-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  transition: all 0.3s ease;
  min-width: 0;
  flex-shrink: 0;
}

.settlement-card:hover {
  border-color: rgba(0, 201, 81, 0.15);
  background: rgba(255, 255, 255, 0.05);
}

/* 用户头像 */
.user-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  border: 2px solid rgba(0, 201, 81, 0.2);
  background: rgba(0, 201, 81, 0.08);
}

.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 用户信息 */
.user-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex-shrink: 0;
}

.user-name {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
}

.user-uid {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.35);
  font-family: "SF Mono", "Courier New", monospace;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

/* 结算金额 */
.settle-amount {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.amount-label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.3);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.amount-value {
  font-size: 22px;
  font-weight: 800;
  color: #00c951;
  font-family: "SF Mono", "Courier New", monospace;
  white-space: nowrap;
}

.amount-symbol {
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 201, 81, 0.6);
}

/* 产品类型 + 收益类别 */
.product-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;
  min-width: 0;
}

.product-type {
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  padding: 2px 10px;
  border-radius: 6px;
  background: rgba(0, 180, 255, 0.08);
  border: 1px solid rgba(0, 180, 255, 0.12);
  white-space: nowrap;
  text-align: center;
}

.income-type {
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.45);
  padding: 2px 10px;
  border-radius: 6px;
  background: rgba(124, 58, 237, 0.08);
  border: 1px solid rgba(124, 58, 237, 0.12);
  white-space: nowrap;
  text-align: center;
}

/* 状态 */
.settle-status {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 20px;
  background: rgba(0, 201, 81, 0.1);
  border: 1px solid rgba(0, 201, 81, 0.15);
  flex-shrink: 0;
}

.status-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #00c951;
  animation: status-pulse 2s ease-in-out infinite;
}

@keyframes status-pulse {
  0%,
  100% {
    opacity: 1;
    box-shadow: 0 0 0 0 rgba(0, 201, 81, 0.4);
  }
  50% {
    opacity: 0.7;
    box-shadow: 0 0 0 4px rgba(0, 201, 81, 0);
  }
}

.status-text {
  font-size: 12px;
  font-weight: 600;
  color: #00c951;
  white-space: nowrap;
}

/* 结算时间 */
.settle-time {
  display: flex;
  align-items: center;
  gap: 4px;
  color: rgba(255, 255, 255, 0.3);
  font-size: 11px;
  flex-shrink: 0;
  white-space: nowrap;
}

.settle-time svg {
  color: rgba(255, 255, 255, 0.2);
  width: 12px;
  height: 12px;
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .settlement-float {
    padding: 10px 12px;
  }

  .settlement-card {
    padding: 10px 14px;
    gap: 10px;
  }

  .user-avatar {
    width: 40px;
    height: 40px;
  }

  .amount-value {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .settlement-float {
    padding: 8px 10px;
  }

  .settlement-card {
    padding: 8px 10px;
    gap: 8px;
  }

  .user-name {
    font-size: 13px;
  }

  .user-uid {
    font-size: 10px;
  }

  .amount-value {
    font-size: 18px;
  }

  .product-type,
  .income-type {
    font-size: 10px;
    padding: 1px 8px;
  }

  .settle-status {
    padding: 2px 8px;
  }

  .status-text {
    font-size: 11px;
  }

  .settle-time {
    font-size: 10px;
  }
}

.xsgq1 {
  display: flex;
  gap: 5px;
}

.xsgq {
  width: 20px;
  height: 20px;
  overflow: hidden;
  border-radius: 50%;
  position: relative;
}

.xsgq img {
  position: absolute;
  height: 120%;
  left: -5px;
  top: -3px;
}

.xsdg1 {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
}
</style>
